export function BasicLayout({ children }: { children: React.ReactNode }) {
  return <main className="h-dvh w-full px-4 pt-2 pb-4 [&>div]:h-full">{children}</main>
}
